import { useLocation, Link } from "wouter";
import { useScroll } from "@/lib/hooks/use-scroll";
import { Menu, X } from "lucide-react";

interface HeaderProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
}

export function Header({ isMenuOpen, onToggleMenu }: HeaderProps) {
  const scrolled = useScroll();
  const [location] = useLocation();
  const isHome = location === "/";
  const solid = scrolled || !isHome;

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        solid
          ? "bg-[#ECE9E0]/95 backdrop-blur-md py-4 border-b border-[#293129]/10"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        <Link href="/" className="flex flex-col items-center cursor-pointer group">
          <span className="text-[9px] tracking-[0.3em] font-bold mb-1 opacity-70">
            DESERT HOT SPRINGS
          </span>
          <span className="font-serif text-2xl md:text-3xl font-bold uppercase tracking-widest group-hover:opacity-70 transition-opacity">
            Miracle Hill
          </span>
        </Link>
        <button
          onClick={onToggleMenu}
          className="z-50 p-2 focus:outline-none text-[#293129] mix-blend-difference"
        >
          {isMenuOpen ? (
            <X size={36} color="#ECE9E0" />
          ) : (
            <Menu size={36} strokeWidth={1.5} />
          )}
        </button>
      </div>
    </nav>
  );
}
